"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = AnnotationLabel;

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _classnames = require("../classnames");

var _classnames2 = _interopRequireDefault(_classnames);

var _Type = require("./Type");

var _Type2 = _interopRequireDefault(_Type);

var _ConnectorLine = require("../Connector/ConnectorLine");

var _ConnectorLine2 = _interopRequireDefault(_ConnectorLine);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function AnnotationLabel(props) {
  var className = (0, _classnames2.default)("label", props.className);
  return (0, _Type2.default)(_extends({}, props, { className: className }), _ConnectorLine2.default, {
    align: "middle"
  });
}